import { Switch } from '@sunwebgroup/uds-ui/switch'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from 'react-intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { useUserReviews } from '@/scopes/products/user-reviews/hooks'
import { createUserReviewsEvent } from '@/scopes/products/user-reviews/infrastructure/analytics'
import styles from './InWebsiteLanguageFilter.module.css'

export function InWebsiteLanguageFilter() {
  const intl = useIntl()

  const { showOnlyInWebsiteLanguage, setShowOnlyInWebsiteLanguage } = useUserReviews()
  const { sendEvent } = useAnalytics()

  const handleOnCheckedChange = () => {
    sendEvent(
      createUserReviewsEvent({
        description: 'show review in own language',
        element: 'Toggle',
        result: showOnlyInWebsiteLanguage ? 'off' : 'on',
      }),
    )
    setShowOnlyInWebsiteLanguage(!showOnlyInWebsiteLanguage)
  }

  return (
    <label className={styles.wrapper}>
      <Switch checked={showOnlyInWebsiteLanguage} onCheckedChange={handleOnCheckedChange} />
      <Typography variant="body-m-bold-tight" className={styles.filterLabel}>
        {intl.formatMessage({ id: 'reviews_all_in_my_language' })}
      </Typography>
    </label>
  )
}
